import React from 'react'
import './TitleBar.css'

const TitleBar = () => (
  <div id='TitleBar'>
    <h1 className='text'>Have Fun Learning Spanish!</h1>
  </div>
);

export default TitleBar



// WEBPACK FOOTER //
// ./src/components/Header/TitleBar/TitleBar.js